// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__TzsQu","title":"styles_title__3cRRX"};